<template>
	<section class="cookies_sec container-wrap">
		<div class="container-box">
			<div class="row">
				<div class="col-sm-12">
					<div class="cookies_inn">
						<span>{{ $t('new_ui.cookies_page.cookies_inn.label') }}</span>
						<h4>{{ $t('new_ui.cookies_page.cookies_inn.title.one') }}</h4>
						<p>
							{{ $t('new_ui.cookies_page.cookies_inn.paragraph') }}
						</p>
						<div class="cookies_mid">
							<h6>{{ $t('new_ui.cookies_page.cookies_mid.title') }}</h6>
							<p>
								{{ $t('new_ui.cookies_page.cookies_mid.paragraph.one') }}
								<br />{{ $t('new_ui.cookies_page.cookies_mid.paragraph.two') }}
							</p>
							<div class="cookies_mid_btn">
								<a href="#">{{
									$t('new_ui.cookies_page.cookies_mid.cta_button.one')
								}}</a>
								<a href="#">{{
									$t('new_ui.cookies_page.cookies_mid.cta_button.two')
								}}</a>
							</div>
						</div>
						<p>
							{{ $t('new_ui.cookies_page.cookies_mid.para.one') }}
						</p>

						<p>
							{{ $t('new_ui.cookies_page.cookies_mid.para.two') }}
						</p>

						<p>
							{{ $t('new_ui.cookies_page.cookies_mid.para.three') }}
						</p>

						<div class="cookies_mid">
							<h6>
								{{ $t('new_ui.cookies_page.cookies_mid.sub_title.one') }}
								<br />{{ $t('new_ui.cookies_page.cookies_mid.sub_title.two') }}
							</h6>

							<div class="cookies_mid_btn">
								<a href="#">{{
									$t('new_ui.cookies_page.cookies_mid.last_cta_button.one')
								}}</a>
								<a href="#">{{
									$t('new_ui.cookies_page.cookies_mid.last_cta_button.two')
								}}</a>
								<a href="#">{{
									$t('new_ui.cookies_page.cookies_mid.last_cta_button.three')
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import cookiesban from '@/assets/images/sub/cookies_ban.png';

export default {
	data: () => {
		return {
			img: {
				image1: cookiesban,
			},
		};
	},
};
</script>
